import ArrowDropDown from "@website/icons/components/arrow-drop-down";
import { PassengerCountPropertiesType } from "@website/ticket-ui/common/components/passenger-count-old/types";
import { CounterButton } from "@website/ui-old/counter-button";
import pick from "lodash-es/pick";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";

export const usePassengerCount = (properties: PassengerCountPropertiesType) => {
  const { onSubmit, list, title, result } = properties;
  const [open, setOpen] = useState<boolean>(false);
  const router = useRouter();

  const onClickChips = useCallback(() => {
    setOpen(true);
  }, []);

  const onClosePopover = useCallback(() => {
    setOpen(false);
  }, []);

  const onClickSubmit = useCallback(() => {
    onClosePopover();
    onSubmit();
  }, [router]);

  return {
    submitButtonProps: {
      onClick: onClickSubmit,
      color: "secondary" as const,
      size: "large" as const,
      fullWidth: true,
      datatestid: "passenger-count-submit"
    },
    chipsProps: {
      variant: "outline" as const,
      EndIcon: <ArrowDropDown />,
      text: result,
      selected: true,
      color: "secondary" as const,
      onClick: onClickChips,
      datatestid: "passenger-count-chip"
    },
    popoverProps: {
      onClose: onClosePopover,
      open,
      title: title,
      datatestid: "passenger-count-popover"
    },
    list: list.map((item) => ({
      title: item.title,
      subtitle: item.subtitle,
      role: "default",
      "data-testid": "passenger-count-item",
      EndAction: (
        <CounterButton
          aria-label={item.title}
          color="secondary"
          variant="outline"
          {...pick(item, "decreaseDisabled", "increaseDisabled", "onChange")}
          locale="fa"
          value={item.value}
        />
      )
    })),
    submitText: "تایید"
  };
};
